import { render } from "./CartFooter.vue?vue&type=template&id=1de451d2&scoped=true"
import script from "./CartFooter.vue?vue&type=script&lang=js"
export * from "./CartFooter.vue?vue&type=script&lang=js"

import "./CartFooter.vue?vue&type=style&index=0&id=1de451d2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de451d2"]])

export default __exports__